import { StyleDeclarationValue, css } from 'aphrodite';
import * as React from 'react';
import { Route, Switch, useHistory, useRouteMatch } from 'react-router-dom';
import { useEventLogging } from '../../../models/Logging';
import { useErrorMessagesContext } from '../../components/ErrorModalProvider/context';
import { EventSurvey } from '../../components/surveys/EventSurvey';
import { IEventRegistrationSurvey } from '../../models/Api';
import { useSurvey } from '../../models/hooks';
import { Survey } from '../Survey';
import { styleSheet } from './styles';

interface IProps {
	className?: string;
	styles?: StyleDeclarationValue[];
}

export const RegisterForEvent: React.FC<IProps> = props => {
	const { className, styles = [] } = props;
	const { params: urlParams = {}, path: matchPath } = useRouteMatch<{
		token?: string;
	}>();
	const h = useHistory();
	const { logApiError } = useEventLogging('RegisterForEvent');
	const { pushError } = useErrorMessagesContext();

	const { hasAccessToken, isUnavailable, surveyQuery } = useSurvey<IEventRegistrationSurvey>({
		accessToken: urlParams.token,
		options: {
			expand: 'options',
		},
	});

	React.useEffect(() => {
		if (!hasAccessToken) {
			return;
		}

		if (surveyQuery.error) {
			logApiError('Survey-Error', surveyQuery.error);
			pushError(surveyQuery.error);
			return;
		}

		if (surveyQuery.data && isUnavailable) {
			h.push(`${matchPath.toLocaleLowerCase().replace(':token?', 'unavailable')}`);
		}
	}, [h, hasAccessToken, isUnavailable, logApiError, matchPath, pushError, surveyQuery.data, surveyQuery.error]);

	const onRenderHeader = React.useCallback(() => {
		return (
			<section className={css(styleSheet.header)}>
				<h2 className={css(styleSheet.heading)}>{surveyQuery.data?.name}</h2>
				{surveyQuery.data?.companyDisplayName ? <p>{surveyQuery.data.companyDisplayName}</p> : null}
			</section>
		);
	}, [surveyQuery.data]);

	return (
		<Survey
			cardStyles={[styleSheet.surveyContent]}
			className={`register-for-event-container ${className || ''}`}
			onRenderHeader={onRenderHeader}
			styles={[styleSheet.container, ...styles]}
		>
			<Switch>
				<Route path={`${matchPath.toLocaleLowerCase().replace(':token?', 'unavailable')}`}>
					<div className={css(styleSheet.unavailable)}>
						<p>This event is not available at this time.</p>
					</div>
				</Route>
				<Route>
					<EventSurvey survey={surveyQuery?.data} />
				</Route>
			</Switch>
		</Survey>
	);
};
